import approvalService from "src/components/approvals/ApprovalService"

export const BATCH_UPDATE_RECORD_TYPE_NAME = "BatchUpdate"

export const APPROVE_ACTION_NAME = "Approve"
export const REJECT_ACTION_NAME = "Reject"

export const PENDING_STATUS_NAME = "Pending"
export const APPROVED_STATUS_NAME = "Approved"
export const REJECTED_STATUS_NAME = "Rejected"

/** Matches ApprovalActions.Comments, varchar(256). */
export const APPROVAL_COMMENT_MAX_LENGTH = 256

/** The audit trail records the action taken; the UI reads better in past tense. */
const ACTION_PAST_TENSE: Record<string, string> = {
	[APPROVE_ACTION_NAME]: APPROVED_STATUS_NAME,
	[REJECT_ACTION_NAME]: REJECTED_STATUS_NAME,
}

export const toPastTense = (action: string): string =>
	ACTION_PAST_TENSE[action] ?? action

/** Resolved at runtime so the frontend cannot drift from the environment's id. */
export const resolveBatchUpdateRecordTypeId = async (): Promise<
	number | null
> => {
	if (approvalService.recordTypes.length === 0) {
		await approvalService.loadRecordTypes()
	}

	return approvalService.getRecordTypeId(BATCH_UPDATE_RECORD_TYPE_NAME)
}

export const getActionTypeId = (name: string): number =>
	approvalService.reference.ApprovalActionTypes.find((a) => a.Name === name)
		?.ApprovalActionTypeId ?? -1

export const getEmployeeName = (employeeId: number): string => {
	const employee = approvalService.retrieveEmployeeFromMap(employeeId)

	return employee
		? `${employee.FirstName} ${employee.LastName}`
		: `Employee ${employeeId}`
}
